/* eslint-disable vue/no-dupe-keys */
/* eslint-disable key-spacing */

<template>

<div class="cui-form--mobile-steps">
  <form-wizard :title="$vuetify.lang.t('$vuetify.create-account')" subtitle="" color="#6a98a0"  error-color="#e74c3c"
  :back-button-text="$vuetify.lang.t('$vuetify.cui-previous') |capitalize" :finish-button-text="$vuetify.lang.t('$vuetify.cui-submit')| capitalize"
   ref="wizard" @on-complete="onComplete">
  <tab-content :title="$vuetify.lang.t('$vuetify.cui-user-profile')" icon="ti-user" :before-change="()=>validateStep('step1')" >
    <user-login :finalModel="finalModel" ref="step3" @on-validate="mergePartialModels"></user-login>
    <user-profile ref="step1" @on-validate="mergePartialModels" ></user-profile>
  </tab-content>
   <tab-content ref="step2" title="Organization" icon="ti-save-alt" >
    <organization  :finalModel="finalModel" @on-click="goToLoginAfterSelectingAppl" @on-validate="mergePartialModels" ></organization>
   </tab-content>
   <tab-content :title="$vuetify.lang.t('$vuetify.cui-login')" icon="ti-id-badge" :before-change="()=>validateStep('step3')" >
     <user-login :finalModel="finalModel" ref="step3" @on-validate="mergePartialModels"></user-login>
   </tab-content>
     <tab-content :title="$vuetify.lang.t('$vuetify.cui-applications')" icon="ti-package"  :before-change="()=>validateStep('step4')" >
       <applications :finalModel="finalModel"  ref="step4" @on-validate="mergePartialModels"></applications>
   </tab-content>
      <tab-content :title="$vuetify.lang.t('$vuetify.cui-review')" icon="ti-check" :before-change="()=>validateStep('step5')">
      <user-review ref="step5" @on-click="goToRequestedTab" :finalModel="finalModel"  @on-validate="mergePartialModels"></user-review>
   </tab-content>
    <div class=".cui-loading__container--organization-list" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
   </div>
      <template slot="footer" slot-scope="props">
       <div class="wizard-footer-left">
           <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">{{$vuetify.lang.t('$vuetify.cui-previous') |capitalize}}</wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button @click.native="props.nextTab()"  v-if="!(props.activeTabIndex === 1) && !props.isLastStep" :style="props.fillButtonStyle">Next</wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button @click.native="onComplete"  v-if="props.isLastStep" :style="props.fillButtonStyle">{{$vuetify.lang.t('$vuetify.cui-submit')| capitalize}}</wizard-button>
        </div>
      </template>
</form-wizard>
</div>
</template>

<script>
import UserProfile from '@/components/pages/registration/userProfile'
import UserReview from '@/components/pages/registration/userReview'
import UserLogin from '@/components/pages/registration/userLogin'
import Organization from '@/components/pages/registration/organization'
import Applications from '@/components/pages/registration/applications'
import Countries from '@/plugins/factory/Countries'
// eslint-disable-next-line no-unused-vars
import Vuelidate from 'vuelidate'

export default {
  components: {
    UserProfile,
    Vuelidate,
    UserLogin,
    UserReview,
    Organization,
    Applications
  },
  props: {
    panel: [[true]]
  },
  data: function () {
    return {
      spinner: false,
      finalModel: {
        data: this.getOrganizations(),
        applications: []
      },
      Countries: Countries.countries
    }
  },
  mounted () {
    this.getOrganizations() // method1 will execute at pageload
    this.$parent.$refs.pageWrap.classList.add('translate3d')
  },
  methods: {
    mergePartialModels (model, isValid) {
      if (isValid) {
      // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model)
      }
      // this.$refs.wizard.changeTab(0, 2)
    },
    goToRequestedTab (index) {
      this.$refs.wizard.changeTab(4, index)
    },
    validateStep (name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validate()
    },
    goToLoginAfterSelectingAppl () {
      this.$refs.wizard.changeTab(1, 2)
    },
    getOrganizations () {
      const data = {}
      this.$API.initiateNonce()
        .then(() => {
          //  2-13-2017 filter resuts by status is not available for count now.
          return this.$API.getOrganizationsCountNonce()
        })
        .then((res) => {
          data.organizationCount = res
          return this.$API.getOrganizationsWithNonce({qs: [['page', 1], ['pageSize', 10], ['status', 'active']]})
        })
        .then(res => {
          data.organizations = res
          this.$store.dispatch('setOrganizations', res)
          return this.$API.getSecurityQuestionsNonce()
        })
        .then(res => {
          const questions = res

          data.securityQuestions = res
          // Split questions to use between 2 dropdowns
          questions.splice(0, 1)
          const numberOfQuestionsFloor = Math.floor(questions.length / 2)

          data.challengeQuestions1 = questions.slice(0, numberOfQuestionsFloor)
          data.challengeQuestions2 = questions.slice(numberOfQuestionsFloor)
        })
        .fail(error => {
          console.log(error)
        })
      return data
    },
    person (registrationData) {
      var personData = {}
      var countryObj = Countries.getCountryByName(registrationData.userProfile.addresses.country)
      registrationData.userProfile.addresses.country = countryObj.code
      personData.addresses = []
      personData.phones = []
      personData.addresses[0] = registrationData.userProfile.addresses
      personData.addresses[0].streets = []
      personData.addresses[0].streets[0] = registrationData.userProfile.address1
      personData.addresses[0].streets[1] = registrationData.userProfile.address2
      personData.email = registrationData.userProfile.email
      personData.language = registrationData.userProfile.language
      personData.timezone = registrationData.userProfile.timezone
      personData.name = registrationData.userProfile.name
      personData.phones[0] = registrationData.userProfile.phones
      personData.organization = { 'id': registrationData.organizationDetails.id }
      return personData
    },
    passwordAccount (registrationData) {
      return {
        version: '1',
        username: registrationData.userLogin.userId,
        password: registrationData.userLogin.password,
        passwordPolicy: registrationData.organizationDetails.passwordPolicy,
        authenticationPolicy: registrationData.organizationDetails.authenticationPolicy
      }
    },
    securityQuestionAccount (registrationData) {
      return {
        version: '1',
        questions: [{
          question: {
            id: registrationData.userLogin.securityQuestion1,
            type: 'question',
            realm: registrationData.organizationDetails.realm
          },
          answer: registrationData.userLogin.answer1,
          index: 1
        },
        {
          question: {
            id: registrationData.userLogin.securityQuestion2,
            type: 'question',
            realm: registrationData.organizationDetails.realm
          },
          answer: registrationData.userLogin.answer2,
          index: 2
        }]
      }
    },
    servicePackageRequest (personId, personRealm, registrationData) {
      let request = {
        registrant: {
          id: personId,
          type: 'person',
          realm: personRealm
        },
        justification: registrationData.requestReason || 'User Walkup Registration'
      }
      request.packages = []
      if (registrationData.selectedApps) {
        for (var i = 0; i < registrationData.selectedApps.length; i++) {
          if (registrationData.selectedApps[i] === true) {
            request.packages.push({
              id: registrationData.applications[i].servicePackage.id,
              type: 'servicePackage'
            })
          }
        }
      }
      return request
    },
    buildRegistrationData (registrationData) {
      return {
        person: this.person(registrationData),
        passwordAccount: this.passwordAccount(registrationData),
        securityQuestionAccount: this.securityQuestionAccount(registrationData)
      }
    },
    onComplete () {
      this.spinner = true
      const registrationData = Object.assign({}, this.finalModel)
      const submitData = this.buildRegistrationData(registrationData)
      this.$API.initiateNonce()
        .then(() => {
          return this.$API.postUserRegistrationNonce({data: submitData})
        })
        .then(res => {
          const packageRequestData = this.servicePackageRequest(res.person.id, res.person.realm, registrationData)
          return this.$API.postPersonRequestNonce({data: packageRequestData})
        })
        .then(res => {
          this.spinner = false
          this.$router.push({ name: 'Success' })
        })
        .fail(error => {
          this.spinner = false
          console.log(error)
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/registration/Register.vue